import { Work } from '@mui/icons-material';
import { Box, Container, Stack, Typography } from '@mui/material';

import { InfoCell } from 'components/InfoCell';
import {
  convertToDateShort,
  getLabel,
  reasonForSeparationChoicesObject,
  employmentOptions,
  countryOptions,
  employmentDetailsOption,
} from 'helpers';
import { FullValidatedWorkClaimProps } from 'types/Claims';
export const ValidatedWorkPeriodInfo = (props: FullValidatedWorkClaimProps) => {
  const {
    id,
    validated_work_claim_end_date,
    contract_id,
    organization,
    validated_work_claim_start_date,
    cage_number,
    employment_details,
    employment_details_other,
    job_title,
    employer_provided_date_of_birth,
    badge_id,
    job_location,
    full_part_time,
    reason_for_separation,
    contract_additional_information,
    contract_supervisor_given_name,
    contract_supervisor_surname,
    contract_supervisor_email,
    ready_for_admin_approval,
  } = props;
  return (
    <Container>
      <Box
        sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', mt: 3 }}
      >
        <Work sx={{ mr: 1 }} />
        <Typography
          sx={{ fontWeight: 'bold' }}
          variant='body1'
        >{`Work Period ${id} `}</Typography>
        <Typography variant='body1'>{` (${convertToDateShort(
          validated_work_claim_start_date,
        )} - ${convertToDateShort(
          validated_work_claim_end_date,
        )})`}</Typography>{' '}
      </Box>
      <Stack>
        {organization &&
          InfoCell({
            title: 'Submitted By (Company)',
            value: organization.name,
          })}
        {contract_id && InfoCell({ title: 'Contract ID:', value: contract_id })}
        {cage_number && InfoCell({ title: 'Cage ID:', value: cage_number })}
        {contract_additional_information &&
          InfoCell({
            title: 'Additional Information:',
            value: contract_additional_information,
            noWrap: false,
          })}
        {badge_id && InfoCell({ title: 'Badge ID:', value: badge_id })}
        {job_location &&
          InfoCell({
            title: 'Job Location:',
            value: getLabel({ value: job_location, options: countryOptions }),
          })}
        {job_title &&
          InfoCell({
            title: 'Job Title:',
            value: job_title,
            noWrap: false,
          })}
        {employer_provided_date_of_birth &&
          InfoCell({
            title: 'Date Of Birth:',
            value: convertToDateShort(employer_provided_date_of_birth),
          })}
        {contract_supervisor_given_name &&
          InfoCell({
            title: 'Supervisor Given Name:',
            value: contract_supervisor_given_name,
          })}
        {contract_supervisor_surname &&
          InfoCell({
            title: 'Supervisor Surname:',
            value: contract_supervisor_surname,
          })}
        {contract_supervisor_email &&
          InfoCell({
            title: 'Supervisor Email:',
            value: contract_supervisor_email,
          })}
        {full_part_time &&
          InfoCell({
            title: 'Full/Part Time:',
            value: getLabel({
              value: full_part_time,
              options: employmentOptions,
            }),
          })}
        {reason_for_separation &&
          InfoCell({
            title: 'Reason For Separation:',
            value: getLabel({
              value: reason_for_separation,
              options: reasonForSeparationChoicesObject,
            }),
          })}
        {employment_details &&
          InfoCell({
            title: 'Employment Details:',
            value: getLabel({
              value: employment_details,
              options: employmentDetailsOption,
            }),
          })}
        {employment_details_other &&
          InfoCell({
            title: 'Employment Details (Other):',
            value: employment_details_other,
            noWrap: false,
          })}
        {ready_for_admin_approval &&
          InfoCell({
            title: 'Ready For Admin Approval:',
            value: `${ready_for_admin_approval}`,
          })}
      </Stack>
    </Container>
  );
};
